import { render, staticRenderFns } from "./swipe-vertical.vue?vue&type=template&id=f00d361c"
import script from "./swipe-vertical.vue?vue&type=script&lang=js"
export * from "./swipe-vertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports